"use client";

import React, { useState } from "react";
import { Typography } from "@/components/ui";

interface AppsSearchAndFilterProps {
  onSearchChange?: (searchTerm: string) => void;
  onFilterChange?: (filter: string) => void;
}

export function AppsSearchAndFilter({ onSearchChange, onFilterChange }: AppsSearchAndFilterProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("*");

  const filterButtons = [
    { label: "All", value: "*" },
    { label: "Business", value: ".business" },
    { label: "Social Media", value: ".social" },
    { label: "Communication", value: ".communications" },
    { label: "News", value: ".news" },
    { label: "QSR", value: ".qsr" },
  ];

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    onSearchChange?.(value);
  };

  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    onFilterChange?.(filter);
  };

  return (
    <div className="flex flex-col gap-6 items-start">
      <input
          type="text"
          className="form-control w-full max-w-[300px] block px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-300"
          id="quicksearch"
          placeholder="Search Apps..."
          value={searchTerm}
          onChange={handleSearchChange}
          aria-label="Search for digital signage apps"
        />

      <div className="filter-buttons flex flex-wrap justify-center gap-3">
        {filterButtons.map((button) => (
          <button
            key={button.value}
            type="button"
            className={`filter-btn px-5 py-1.5 rounded-md border transition-all duration-300 text-sm font-medium ${
              activeFilter === button.value
                ? "bg-primary text-white border-primary"
                : "bg-white text-text-secondary border-gray-300 hover:border-primary hover:text-primary"
            }`}
            data-filter={button.value}
            onClick={() => handleFilterChange(button.value)}
          >
            {button.label}
          </button>
        ))}
      </div>
    </div>
  );
}
